export const createPageName = (pageName, pageView) => {
  return pageView ? `${pageName}-${pageView}` : pageName;
};
